import { useMemoizedFn } from 'ahooks';
import { useSetAtom } from 'jotai';
import { queryCartCountAtom } from '@/atoms';
import { MsgModal } from '@/components';
import { useFormatMessage } from '@/hooks';
import { addToCart } from '@/services/api/cart';
import { API_CODES } from '@/services/constant';
import { useAuthLogin, useCustomerService, useLockAsyncFn } from '.';

export const useAddToCart = () => {
  const queryCartCount = useSetAtom(queryCartCountAtom);
  const { locateToLogin, onAuthLogin } = useAuthLogin();
  const { formatMessage } = useFormatMessage();
  const { openOnline } = useCustomerService();

  const showSuccess = () => {
    MsgModal.info({
      title: formatMessage({ id: 'components.addToCart.success.title' }),
      content: (
        <div className="pt-8 text-center text-cc2 text-14">
          {formatMessage({ id: 'components.addToCart.success.content' })}
        </div>
      ),
      actions: {
        showCancelBtn: true,
      },
      okText: formatMessage({ id: 'components.addToCart.success.okBtn' }),
      onOk: () => {
        window.open('/cart');
      },
      cancelText: formatMessage({
        id: 'components.addToCart.success.cancelBtn',
      }),
      onCancel: () => {
        // window.open('/');
        window.location.reload();
      },
    });
  };

  const showError = () => {
    const modalInstance = MsgModal.info({
      title: formatMessage({ id: 'components.addToCart.error.title' }),
      content: (
        <div className="pt-8 text-center text-cc2 text-14">
          {formatMessage({ id: 'components.addToCart.error.content' })}
        </div>
      ),
      okText: formatMessage({ id: 'components.addToCart.error.okBtn' }),
      onOk: () => {
        openOnline();
        modalInstance.destroy();
      },
    });
  };

  const { asyncFn, loading } = useLockAsyncFn(addToCart, {
    onSuccess: () => {
      queryCartCount();
      showSuccess();
    },
    onFail: (_, res) => {
      if (res?.errorCode === API_CODES.NOT_LOG_IN) {
        locateToLogin();
      } else {
        showError();
      }
    },
  });

  const onAddToCart = (params: API.UserCartItemBatchOperateReq) => {
    onAuthLogin(() => {
      asyncFn(params);
    });
  };

  return {
    onAddToCart: useMemoizedFn(onAddToCart),
    loading,
  };
};
